import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* Put all uiSchema options here, in the template they go under ui:options: */
export const CostCenterCheckerUiOptionsSchema = z.object({
  debounceMs: z.number().optional().describe('Debounce delay in milliseconds'),
  currentUriPrefix: z
    .string()
    .optional()
    .describe(
      'URI prefix of the instance being edited. When set, the duplicate check ' +
        'only warns if another instance with a different URI prefix shares the ' +
        'same cost center (edit mode). Omit for create mode.',
    ),
});

// Transforms the Zod schema to a TypeScript type
export type CostCenterCheckerUiOptions = z.infer<
  typeof CostCenterCheckerUiOptionsSchema
>;

/* The field schema for the CostCenterChecker field extension */
export const CostCenterCheckerFieldSchema = makeFieldSchemaFromZod(
  z.string().describe('Cost Center Checker'),
  CostCenterCheckerUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type CostCenterCheckerProps = typeof CostCenterCheckerFieldSchema.type;

/* The final custom field extension schema used for the field extension */
export const CostCenterCheckerSchemaFinal = CostCenterCheckerFieldSchema.schema;
